import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import AutoStoriesOutlinedIcon from "@mui/icons-material/AutoStoriesOutlined";
import HeadphonesOutlinedIcon from "@mui/icons-material/HeadphonesOutlined";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import { useState } from "react";
import { PublicationKind } from "../../types/Publications";
import s from "./Publications.module.css";

const kindIcons = {
  [PublicationKind.BOOK]: AutoStoriesOutlinedIcon,
  [PublicationKind.GUIDE]: MenuBookOutlinedIcon,
  [PublicationKind.AUDIOBOOK]: HeadphonesOutlinedIcon,
  [PublicationKind.OTHER]: ArticleOutlinedIcon,
};

type PublicationArtworkProps = {
  logoUrl?: string;
  kind?: PublicationKind;
  title: string;
};

const PublicationArtwork = ({ logoUrl, kind, title }: PublicationArtworkProps) => {
  const [failedUrl, setFailedUrl] = useState<string | null>(null);

  if (logoUrl && failedUrl !== logoUrl) {
    return (
      <img
        src={logoUrl}
        alt={`${title} artwork`}
        className={s.artwork}
        onError={() => setFailedUrl(logoUrl)}
      />
    );
  }

  const Icon = kindIcons[kind ?? PublicationKind.OTHER];
  const label = `${kind ? kind.toLowerCase() : "publication"} artwork unavailable`;
  return (
    <div className={s.artworkFallback} role="img" aria-label={label}>
      <Icon aria-hidden="true" />
      <span>{label}</span>
    </div>
  );
};

export default PublicationArtwork;
